import {
  TherapistFilterActive,
  type TherapistFilterActiveProps,
} from '@/src/domains/therapist-filters/components/TherapistFilterActive'
import { useSelectedServiceLocations } from '@/src/domains/therapist-filters/hooks/useSelectedServiceLocations'

export interface TherapistSessionLocationActiveFilterProps
  extends Pick<TherapistFilterActiveProps, 'variant' | 'size'> {
  id: number
  onClick: () => void
}

export const TherapistSessionLocationActiveFilter = ({
  id,
  onClick,
  ...props
}: TherapistSessionLocationActiveFilterProps) => {
  const { data } = useSelectedServiceLocations()

  const location = data?.find((loc) => loc.id === id)

  if (!location) {
    return null
  }

  return (
    <TherapistFilterActive onClick={onClick} {...props}>
      {location.districtName}
    </TherapistFilterActive>
  )
}
